export const cssVar = (name: string): string =>
  getComputedStyle(document.documentElement).getPropertyValue(name).trim()

const FNV_OFFSET_BASIS = 0x811c9dc5
const FNV_PRIME = 0x01000193

// Murmur3's finalizer. Without it, FNV-1a moves names that differ only in the last character
// ("creator1", "creator2") onto neighbouring palette entries.
const mix = (hash: number): number => {
  const a = Math.imul(hash ^ (hash >>> 16), 0x85ebca6b)
  const b = Math.imul(a ^ (a >>> 13), 0xc2b2ae35)
  return (b ^ (b >>> 16)) >>> 0
}

const hashString = (value: string): number =>
  mix(
    Array.from(value).reduce(
      (hash, char) => Math.imul(hash ^ char.charCodeAt(0), FNV_PRIME) >>> 0,
      FNV_OFFSET_BASIS,
    ),
  )

// The palette type is non-empty: with no colors, the modulo would be NaN and there is nothing to return.
export const pickColorFromString = <T extends string>(
  value: string,
  colors: readonly [T, ...T[]],
): T => colors[hashString(value.trim().toLowerCase()) % colors.length]!

export const hexToRgba = (hex: string, alpha: number): string => {
  const normalized = hex.replace('#', '')
  const expanded =
    normalized.length === 3
      ? normalized
          .split('')
          .map((char) => char + char)
          .join('')
      : normalized
  const r = parseInt(expanded.slice(0, 2), 16)
  const g = parseInt(expanded.slice(2, 4), 16)
  const b = parseInt(expanded.slice(4, 6), 16)

  return `rgba(${r}, ${g}, ${b}, ${alpha})`
}
